<script>
export default {
  name: 'ThematicPageHeaderPreview',

  props: {
    title: {
      type: String,
      default: ''
    },

    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <div class="thematic-page-header-preview">
    <div class="thematic-page-header-preview__overlay">
      <h2 class="thematic-page-header-preview__title">
        {{ title }}
      </h2>

      <p
        v-if="subtitle"
        class="thematic-page-header-preview__subtitle"
      >
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.thematic-page-header-preview {
  width: 100%;
  min-height: 160px;
  border-radius: 8px;
  overflow: hidden;
  background-image: url('/assets/images/themes/default/png/partners_banner.png');
  background-size: cover;
  background-position: center;

  &__overlay {
    width: 100%;
    height: 100%;
    min-height: 160px;
    box-sizing: border-box;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: rgba(0, 51, 102, 0.55);
  }

  &__title {
    color: #ffffff;
    font-size: 32px;
    font-weight: 700;
    margin: 0;
    word-break: break-word;
  }

  &__subtitle {
    color: #ffffff;
    font-size: 16px;
    margin: 8px 0 0;
    word-break: break-word;
  }
}
</style>
